// Mock data for enrollment tab
export const mockEnrollmentData = {
    // Top KPIs data
    signedUpUsers: 54400,
    signedUpUsersPercentage: 20,
    userPenetration: 32,
    directDepositSwitches: 8160,
    directDepositSwitchesPercentage: 20,
    directDepositActivation: 15,
    // Bottom KPIs data
    userOptIn: 85000,
    userOptInPercentage: 20,
    optInLoss: 30600,
    optInLossPercentage: 20,
    churnedUsers: 2720,
    churnedUsersPercentage: 20,
    churnRate: 5,
    churnRatePercentage: 20
};

export const enrollmentConfig = {
    title: "Enrollment KPIs",
    topKPIs: [
        {
            key: 'signedUpUsers',
            title: 'Total Users Enrolled',
            percentageKey: 'signedUpUsersPercentage',
        },
        {
            key: 'userPenetration',
            title: 'User Penetration',
            showProgress: true
        },
        {
            key: 'directDepositSwitches',
            title: 'Direct Deposit Switches',
            percentageKey: 'directDepositSwitchesPercentage'
        },
        {
            key: 'directDepositActivation',
            title: 'Direct Deposit Activation',
            showProgress: true            
        }
    ],
    charts: [
        {
            title: 'Enrollment Funnel',
            type: 'enrollmentFunnel'
        },
        {
            title: 'Direct Deposit Switches',
            type: 'directDepositSwitches'
        }
    ],
    bottomKPIs: [
        {
            key: 'userOptIn',
            title: 'User Opt-In',
            percentageKey: 'userOptInPercentage'
        },
        {
            key: 'optInLoss',
            title: 'Opt-In Loss',
            percentageKey: 'optInLossPercentage'
        },
        {
            key: 'churnedUsers',
            title: 'Churned Users',
            percentageKey: 'churnedUsersPercentage'
        },
        {
            key: 'churnRate',
            title: 'Churn Rate',
            percentageKey: 'churnRatePercentage'
        }
    ]
};
